import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import SignUp from './views/SignUp.vue'
import Users from './views/Users.vue'
import Courses from './views/Courses.vue'
import Course from './views/Course.vue'
import UsersList from './views/UsersList'
import CourseTypes from './views/CourseTypes.vue'
import CourseType from './views/CourseType.vue'
import RegisteredUsers from './views/RegisteredUsers.vue'
import User from './views/User.vue'
import LoadingPage from './views/LoadingPage.vue'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'default',
      component: Home,
      meta: {
        authenticated: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/signup',
      name: 'signup',
      component: SignUp
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        authenticated: true
      }
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      meta: {
        is_admin: true
      }
    },
    {
      path: '/users/:id',
      name: 'user',
      component: User,
      meta: {
        is_admin: true
      }
    },
    {
      path: '/courses',
      name: 'courses',
      component: Courses,
      meta: {
        authenticated: true
      }
    },
    {
      path: '/courses/:id',
      name: 'course',
      component: Course,
      meta: {
        authenticated: true
      }
    },
    {
      path: '/courses/:id/usersList',
      name: 'usersList',
      component: UsersList,
      meta: {
        is_admin: true
      }
    },
    {
      path: '/courses/:id/registeredUsers',
      name: 'registeredUsers',
      component: RegisteredUsers,
      meta: {
        is_admin: true
      }
    },
    {
      path: '/courseTypes',
      name: 'courseTypes',
      component: CourseTypes,
      meta: {
        is_admin: true
      }
    },
    {
      path: '/courseTypes/:id',
      name: 'courseType',
      component: CourseType,
      meta: {
        is_admin: true
      }
    },
    {
      path: '/loadingPage',
      name: 'loadingPage',
      component: LoadingPage
    }
  ]
})
